module.exports = __webpack_public_path__ + "img/LOGO_Blue@2x.f0e817dd.png";